import StickyHeaderPresenter from "../../sticky-header/presenter/sticky-header.js";

import CartTopStickySectionView from "../view/top-section.js";

import ModalCallbackFeedbackFormPresenter from "../../modal-callback-feedback-form/presenter/modal-callback-feedback-form.js";

import {
  render,
  removeElement
} from "../../render/render.js";

import {
  getMaxZIndex
} from "../../../utils/get-max-z-index.js";

import {
  defaultCartStickyHeaderModelData
} from "../const.js";

export default class CartStikyHeader extends StickyHeaderPresenter {
  constructor({
    catalogNavigationElement,
    footerElement
  }) {
    super({
      catalogNavigationElement,
      footerElement
    });

    this._defaultModelData = defaultCartStickyHeaderModelData;
  }

  _processRenderTopSection() {
    this._topSectionView = new CartTopStickySectionView();
    render(document.body, this._topSectionView.getElement());
    this._topSectionView.setSectionZIndex(getMaxZIndex() + 1);

    this._animation.fadeIn(
        this._topSectionView.getElement()
    );

    this._modalCallbackFeedbackFormPresenter = new ModalCallbackFeedbackFormPresenter(
        this._topSectionView.getPhoneButtonElement()
    );
    this._modalCallbackFeedbackFormPresenter.init();
  }

  _processDestroyTopSection() {
    const sectionElement = this._topSectionView.getElement();
    this._topSectionView = null;

    this._animation.fadeOut(
        sectionElement,
        null,
        () => {
          removeElement(sectionElement);
        }
    );

    this._modalCallbackFeedbackFormPresenter.reset();
    this._modalCallbackFeedbackFormPresenter = null;
  }
}
